<template>
    <div>
        <span v-if="isHeader">
            <div>
            <CDropdown
                v-tippy="getBaseTippy(crearTippySicn())"
                style="color: white !important;"
                split
                toggler-text="Split Dropdown"
                class="mr-1 btnPrincipalVappDrpw"
                @click="actualizar">
                <template #toggler-content ><!-- :class="isActualizandoEmpresas?'pi-spin':''"-->
                    <div>
                        <span style="font-size: 11px;" class="pi pi-sync mr-1" :class="isActualizandoEmpresas?'pi-spin':''"></span> 
                        <span style="font-size: 11px; color: white !important;">
                            <span v-show="!isActualizandoEmpresas">Sincorizar Empresas</span>
                            <span v-show="isActualizandoEmpresas">Detener Sincronización</span>
                        </span>

                        <!--<span class="pi pi-check-circle" :class="colorDifFecha"></span>-->
                    </div>
                    <!--<div style="font-size: 9px;"><span :class="colorDifFecha">({{ formatearFecha(ultActualizacion) }})</span></div>-->
                        
                </template>
                <div role="group">
                    <CDropdownHeader :class="colorDifFecha" style="font-size: 9px;">
                        <!--<CIcon
                            style="color:#f9b115"
                            :content="$options.freeSet.cilWarning"
                        /> -->Última Sincronización {{ formatearFecha(ultActualizacion) }}
                    </CDropdownHeader>
                    <CDropdownItem @click="desplegarEmpresas" :class="colorDifFecha">
                        <span class="pi pi-eye mr-1"></span>Mostrar más información
                    </CDropdownItem>

                </div>
            </CDropdown>
        </div>
            <!--
            <CButton 
                :disabled="isActualizandoEmpresas" 
                @click="actualizar"
                v-tippy="getBaseTippy(`Actualizar Empresas de ${(tipoBd=='CONTA'?'Contabilidad':'Remuneraciones')}`)"
                class="btnPrincipalVapp"
                size="sm"
                variant="ghost">
                <span class="pi pi-sync" :class="isActualizandoEmpresas?'pi-spin':''"></span> Sincronizar Empresas
            </CButton>

            <CButton
                class="btnPrincipalVapp ml-1"
                style="width:auto"
                size="sm"
                color="danger"
                @click="cancelarActualizaciones"
                v-show="isActualizandoEmpresas"
                v-tippy="getBaseTippy(`Cancelar Sincronización`)"
                >
                <CIcon :content="$options.freeSet.cilXCircle" /> <span >Detener Sincronización</span>
            </CButton>-->

            <span :class="colorDifFecha" class="ml-3">
                <!--<span class="mt-2 ml-2 mr-1 desplegarEmpresas pi pi-eye" :class="colorDifFecha" @click="desplegarEmpresas"
                    v-tippy="getBaseTippy(`Ver más información empresas`)">
                </span>-->
                
                <span class="text-capitalize" v-tippy="getBaseTippy(`Última Sincronización ${ $utils.calcularDifecenciaDias(ultActualizacion) }`)">Última Sincronización: {{ formatearFecha(ultActualizacion) }}</span>
                
                <span class="text-capitalize ml-1"
                    v-show="mostrarSugerencia"
                    v-tippy="getBaseTippy(`**Ha pasado mucho tiempo sin sincronizar, le sugerimos sincronizar su información`)">
                    <span
                        class="pi pi-exclamation-circle"
                        style="font-size: 1rem;">
                    </span>
                </span>
                
            </span>
            

                
            <ModalEmpresasInfo 
                :loadingEmpresas="isLoadingEmpresasInfo"
                :mostrarModal="mostrarModalInfoEmpresas" 
                :empresasInfo="empresasInfo" 
                :tipoBd="tipoBd" 
                :ultActualizacion="ultActualizacion" 
                :isActualizandoEmpresas="isActualizandoEmpresas" 
                :mostrarSugerencia="mostrarSugerencia" 
                :empresasFinalizadas="empresasFinalizadas"
                @actualizarEmpresas="actualizar"
                @cerrarModal="cerrarModalInfoEmpresa"
                @cancelarActualizacion="cancelarActualizaciones"
                @refreshFechaActualizacion="getUltimaActualizacion" />
        </span>
        
        <span v-else>
            <CRow>
                <CCol>
                    <CButton
                        v-tippy="getBaseTippy(`Sincronizar Empresas de ${(tipoBd=='CONTA'?'Contabilidad':'Remuneraciones')}`)"
                        class="btnPrincipalVapp mb-1"
                        style="width:auto"
                        variant="ghost"
                        size="sm"
                        color="success"
                        @click="actualizar"
                        :disabled="isActualizandoEmpresas">
                        <CIcon :content="$options.freeSet.cilLoopCircular" :class="classActualizar" /> <span>{{textoBtnActualizarEmpresas}}</span>
                    </CButton>
                    <CButton
                        class="btnPrincipalVapp mb-1"
                        style="width:auto"
                        size="sm"
                        color="danger"
                        @click="cancelarActualizarEmpresas"
                        v-show="isActualizandoEmpresas"
                        content="Cancelar Actualización"
                        v-tippy="{ 
                            placement: 'right',
                            arrow: true, 
                            arrowType: 'round', 
                            animation:'fade',
                            theme: 'google' 
                        }">
                        <CIcon :content="$options.freeSet.cilXCircle" /> <span >Detener Sincronización</span>
                    </CButton>
                    <CButton
                        class="ml-1 mb-1"
                        style="width:auto"
                        size="sm"
                        v-show="mensajesActualizacion.length>0"
                        @click="mostrarMensajes = !mostrarMensajes"
                        content="Mostrar/Ocultar"
                        v-tippy="{ 
                            placement: 'right',
                            arrow: true, 
                            arrowType: 'round', 
                            animation:'fade',
                            theme: 'google' 
                        }">
                        
                        <CIcon v-show="mostrarMensajes" :content="$options.freeSet.cilChevronTop" />
                        <CIcon v-show="!mostrarMensajes" :content="$options.freeSet.cilChevronBottom" />
                    </CButton>
                    
                </CCol>
            </CRow>
            <CRow v-if="!isHeader">
                <CCol md="4">Última Sincronización: <span class="text-capitalize" style="color: #0b7689">{{ formatearFecha(ultActualizacion) }}</span></CCol>
            </CRow>
            <CRow v-if="!isHeader" v-show="mostrarSugerencia">
                <CCol md="4"><span class="text-capitalize" style="color: #7E1146">**Ha pasado mucho tiempo sin sincronizar, le sugerimos sincronizar su información</span></CCol>
            </CRow>
            
            <CRow v-if="!isHeader" v-show="mostrarMensajes">
                <CCol md="8" lg="8">
                    <a-table
                        row-key="codEmpresa"
                        :columns="columnasMensajesAct" 
                        :data-source="mensajesActualizacion"
                        :scroll="{ y: 300 }"
                        class="components-table-demo-nested mt-3" 
                        size="small" 
                        style="overflow:auto;">
                        <slot slot="mensajes" slot-scope="mensaje">
                            <CAlert show color="info" :key="index" v-for="(msj, index) in mensaje.mensajes">
                                {{msj.mensaje}}
                            </CAlert>
                        </slot>
                    </a-table>
                </CCol>
            </CRow>
            
        </span>

    </div>
    
  
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
    import cons from "@/const";
    import axios from "axios";
    import apiUrls from '@/views/utils/apiUrls'

    import { freeSet } from "@coreui/icons";
    import * as util from '@/views/utils/utilsFunctions'

    import { format, formatDistance, formatRelative, subDays, differenceInDays  } from "date-fns";
    import es from "date-fns/locale/es";

    

    import ModalEmpresasInfo from "@/views/utils/componentes/ModalEmpresasInfo"; 
    

    export default {
        name: "ActualizarEmpresas",
        freeSet,
        props: {
            tipoBd: String,
            isHeader: Boolean,
        },
        components: {
            ModalEmpresasInfo,

        },
        data() {
            return {

                urlBase: cons.port+"://" + cons.ipServer,

                tokenLogin: JSON.parse(this.$cookie.get('userLogginToken')).tokenUsuario,
                tipoUserAdmin: JSON.parse(this.$cookie.get('userLogginToken')).tipoUsuario,
                idCliente: JSON.parse(this.$cookie.get('userLogginToken')).idCliente,

                ultActualizacion: null,
                mostrarSugerencia: false,
                colorDifFecha: "rangoFechaSinAlerta",

                rqstActualizarEmpresas: null,
                isActualizandoEmpresas: false,
                classActualizar: "",
                textoBtnActualizarEmpresas: "Actualizar Empresas",
                mensajesActualizacion: [],
                mostrarMensajes: false,

                columnasMensajesAct: [
                    { title: 'Cod Empresa', dataIndex: 'codEmpresa', width: '15%', ellipsis: true, align: 'center'},
                    { title: 'Mensajes', scopedSlots: { customRender: 'mensajes' }, width: '70%', align: 'left'},
                ],
                
                isLoadingEmpresasInfo: false,
                empresasInfo: [],

                mostrarModalInfoEmpresas: false,

                empresasFinalizadas: [],
                empresasActualizando: [],

                limiteActualizacionEmpresas: 5,
                cancelarActualizacion: false,

                comprobacionTimeout: null,

                idIntervaloGetinfo: null,

                socket: null, // Referencia al WebSocket
                connectionStatus: "Desconectado",
                respuesta: null, // Respuesta del servidor

            };
        },
        created: function () {
        },
        beforeMount() {
            this.getUltimaActualizacion()
            this.obtenerSoloInfoEmpresas()
        },
        beforeDestroy(){
            clearInterval(this.idIntervaloGetinfoD)
        },
        mounted(){
            this.idIntervaloGetinfoD = setInterval(function(){ this.obtenerSoloInfoEmpresas(); }.bind(this), 10000);
        },
        methods: {//return format(new Date(fechaDoc), cons.formatoFechaDocumentos, {locale: es})
            compararDatosEmpresa: function(empresa, empresaExistente){

                const cambiosObjeto = {};

                Object.keys(empresa).forEach((key) => {
                    if (empresa[key] !== empresaExistente[key]) {
                        cambiosObjeto[key] = { antes: empresaExistente[key], despues: empresa[key] };
                    }
                });
                // Si hubo cambios, agrega al resultado
                /*if (Object.keys(cambiosObjeto).length > 0) {
                    cambios.push({ idEmpresa: nuevo.idEmpresa, cambios: cambiosObjeto });
                }*/
                return cambiosObjeto

            },
            obtenerSoloInfoEmpresas: function(bd, actualizarSoloEmpreainfo){
                if (document.visibilityState !== "visible") {
                    return
                }

                let bdUso = null
                if(bd == null){
                    bdUso = this.tipoBd
                } else{
                    bdUso = bd
                }

                this.isLoadingEmpresasInfo = true
                var url = this.urlBase + `/get_empresas_info/${bdUso}`;
                axios({
                    method: "GET", 
                    "url": url,
                    "headers": {
                        'Authorization': `${this.tokenLogin}`
                    }
                }).then(result => {
                    let empresasObtenidas = result.data
                    
                    this.empresasInfo = this.empresasInfo.filter((empresaExistente) => {
                        return empresasObtenidas.some((empresa) => empresa.idEmpresa === empresaExistente.idEmpresa);
                    });

                    empresasObtenidas.forEach((empresa) => {
                        if(this.empresasInfo.length > 0){
                            let empresaExistente = this.empresasInfo.find((emp) => emp.idEmpresa === empresa.idEmpresa);
                            
                            if(empresaExistente){
                                let datosDiferentes = this.compararDatosEmpresa(empresa, empresaExistente)
                                Object.keys(datosDiferentes).forEach(llave => {
                                    this.$set(empresaExistente, llave, datosDiferentes[llave].despues)
                                });
                            } else {
                                this.empresasInfo.push({...empresa, mostrarMas: false,});

                            }
                        } else {
                            this.empresasInfo = empresasObtenidas.map((emp) => {
                                this.$set(emp, "mostrarMas", false);
                                return emp;
                            });
                            
                            if(actualizarSoloEmpreainfo){
                                this.actualizarEmpresas()
                            }
                            
                        }
                    })
                    /*
                    this.empresasInfo = result.data;
                    this.empresasInfo.forEach(emp => {
                        this.$set(emp, "mostrarMas", false)
                    })
                    
                    if(actualizarSoloEmpreainfo != null){
                        if(actualizarSoloEmpreainfo){
                            this.actualizarEmpresas()
                        }
                    }*/

                }, error => {})
                .finally(() => {
                    this.isLoadingEmpresasInfo = false
                });
            },
            desplegarEmpresas: function(){
                this.mostrarModalInfoEmpresas = true
            },
            cerrarModalInfoEmpresa: function(){
                this.mostrarModalInfoEmpresas = false
            },
            formatearFecha: function(fecha){
                return util.formatFechaNormal(fecha)
            },
            getUltimaActualizacion: function(bd){
                let bdUso = null
                if(bd == null){
                    bdUso = this.tipoBd
                } else{
                    bdUso = bd
                }
                var url = this.urlBase + apiUrls.general.getActualizacion//"/get_ultima_actualizacion/";
                
                axios({
                    method: "POST", 
                    "url": url,
                    "data": {
                        "info": {
                            "tipoBd": bdUso
                        }
                    },
                    "headers": {
                        'Authorization': this.tokenLogin
                    }
                }
                ).then(result => {
                    this.ultActualizacion = result.data.ultActualizacion

                    this.mostrarSugerencia = util.verDiferenciaFecha(this.ultActualizacion)
                    this.colorDifFecha = util.colorDiferenciaFecha(this.ultActualizacion)
                }, error => {                    
                    this.$notification.error(error.response.data.mensajeGeneral, {  timer: 10, position:"bottomRight", showCloseIcn:true});
                })
                .finally(() => {
                    this.classActualizar = ""
                    this.isActualizandoEmpresas = false
                    this.textoBtnActualizarEmpresas
                    this.textoBtnActualizarEmpresas = "Actualizar Empresas"
                });
            },
            cancelarActualizaciones: function(){
                this.cancelarActualizacion = true
            },
            comprobarEmpresasActualizando: function(){
                if (this.comprobacionTimeout) return

                this.comprobacionTimeout = setTimeout(() => {
                const actualizando = this.empresasInfo.some(empresa => empresa.actualizando);

                    if (!actualizando) {
                        this.isActualizandoEmpresas = false;
                        this.empresasFinalizadas = [];
                        this.$emit("refreshView");
                        this.getUltimaActualizacion(this.tipoBd);
                    }

                    clearTimeout(this.comprobacionTimeout); // Limpia el timeout al finalizar
                    this.comprobacionTimeout = null;
                }, 100);
            },
            actualizar: function(){
                if(this.empresasInfo.length>0){
                    this.actualizarEmpresas()
                } else {
                    this.isActualizandoEmpresas = true;
                    //this.mostrarNotificaciones(2, "ups jasjsaj")
                    
                    const axiosSource = axios.CancelToken.source();
                    this.rqstActualizarEmpresas = { cancel: axiosSource.cancel, msg: "Cargando..." };
                    const url = this.urlBase + apiUrls.general.actualizarBd;

                    axios({
                        method: "POST",
                        url: url,
                        cancelToken: axiosSource.token,
                        data: {
                            info: {
                            actualizarTodoCliente: false,
                            idCliente: this.idCliente,
                            empresasActualizar: [],
                            tipoBd: this.tipoBd,
                            actualizarSoloEmpreainfo: true
                            }
                        },
                        headers: {
                            Authorization: this.tokenLogin
                        }
                    }).then(result => {
                        this.obtenerSoloInfoEmpresas(this.tipoBd, true)
                    }).catch(error => {
                        this.isActualizandoEmpresas = false;
                        this.mostrarNotificaciones(2, error.response.data.mensajeGeneral)
                    }).finally(() => {
                       
                    });

                }
            },
            actualizarEmpresas: function(){
                
                this.isActualizandoEmpresas = true;
                this.cancelarActualizacion = false;
                let index = 0;

                const procesarEmpresas = () => {

                    if (this.cancelarActualizacion) {
                        clearInterval(intervalId);
                        this.isActualizandoEmpresas = false;
                        this.mostrarNotificaciones(2, `Actualización cancelada, se finalizarán las ultimas empresas que quedaron actualizando (${this.empresasActualizando.join(',')})`)
                        return;
                    }
                    // Detiene la función si ya se procesaron todas las empresas
                    if (index >= this.empresasInfo.length && this.empresasActualizando.length === 0) {
                        clearInterval(intervalId);
                        //this.isActualizandoEmpresas = false;
                        this.comprobarEmpresasActualizando()
                        return;
                    }
                    
                    // Revisa si hay espacio en empresasActualizando para agregar más empresas
                    if (this.empresasActualizando.length < this.limiteActualizacionEmpresas && index < this.empresasInfo.length) {
                        
                        
                        let emp = this.empresasInfo[index];
                        this.$set(emp, "actualizando", true);
                        this.$set(emp, "msjActualizacion", []);

                        this.empresasActualizando.push(emp.codEmpresa);
                        /*
                        //`/get_empresas_info/${bdUso}`
                        console.log("asdasd", `ws://${cons.ipServer}/ws/some_path/`)
                        this.socket = new WebSocket(`ws://${cons.ipServer}/ws/some_path/`);

                        // Evento: conexión exitosa
                        this.socket.onopen = () => {
                            this.connectionStatus = "Conectado al WebSocket";
                            console.log("Conexión exitosa con el WebSocket");
                        };

                        // Evento: mensaje recibido
                        this.socket.onmessage = (event) => {
                            const data = JSON.parse(event.data);
                            console.log("Mensaje recibido del servidor:", data);
                            this.respuesta = data;
                        };

                        // Evento: error en la conexión
                        this.socket.onerror = (error) => {
                            console.error("Error en el WebSocket:", error);
                            this.connectionStatus = "Error en la conexión";
                        };

                        // Evento: desconexión
                        this.socket.onclose = () => {
                            this.connectionStatus = "Desconectado del WebSocket";
                            console.log("WebSocket desconectado");
                        };*/

                        // Configura y envía la solicitud con Axios
                        const axiosSource = axios.CancelToken.source();
                        this.rqstActualizarEmpresas = { cancel: axiosSource.cancel, msg: "Cargando..." };
                        const url = this.urlBase + apiUrls.general.actualizarBd;

                        axios({
                            method: "POST",
                            url: url,
                            cancelToken: axiosSource.token,
                            data: {
                                info: {
                                actualizarTodoCliente: false,
                                idCliente: this.idCliente,
                                empresasActualizar: [emp],
                                tipoBd: this.tipoBd
                                }
                            },
                            headers: {
                                Authorization: this.tokenLogin
                            }
                        }).then(result => {
                            this.$set(emp, "msjActualizacion", result.data.mensajesEmpresa);
                            
                        }).catch(error => {
                            this.$set(emp, "msjActualizacion", error.response ? [{"mensajes": [{"mensaje": error.response.data.mensajeGeneral}]}] : [{"mensajes": [{"mensaje": "Error desconocido."}]}]);
                        }).finally(() => {
                            this.$set(emp, "actualizando", false);
                            this.empresasFinalizadas.push(emp.codEmpresa);

                            // Elimina la empresa de empresasActualizando
                            const pos = this.empresasActualizando.indexOf(emp.codEmpresa);
                            if (pos > -1) this.empresasActualizando.splice(pos, 1);

                            this.comprobarEmpresasActualizando();
                        });

                        index++; // Avanza al siguiente índice en empresasInfo
                    }
                };

                // Ejecuta procesarEmpresas en intervalos de 100 ms
                const intervalId = setInterval(procesarEmpresas, 100);
            },
            actualizar2: function(){
                this.isActualizandoEmpresas = true
                for(let emp of this.empresasInfo){
                    this.$set(emp, "actualizando", true)
                    this.$set(emp, "msjActualizacion", [])
                    
                    this.empresasActualizando.push(emp.codEmpresa)
                    
                    const intervalId = setInterval(() => {
                        if (this.empresasActualizando.length == this.limiteActualizacionEmpresas) {
                            clearInterval(intervalId);
                        }
                    }, 100);



                    const axiosSource = axios.CancelToken.source();
                    this.rqstActualizarEmpresas = { cancel: axiosSource.cancel, msg: "Cargando..." };
                    var url = this.urlBase + apiUrls.general.actualizarBd
                    axios({
                        method: "POST", 
                        "url": url,
                        cancelToken: axiosSource.token,
                        "data": {
                            "info": {
                                "actualizarTodoCliente": false,
                                "idCliente": this.idCliente,
                                "empresasActualizar": [emp],
                                "tipoBd": this.tipoBd
                            }
                        },
                        "headers": {
                            'Authorization': this.tokenLogin
                        }
                    }
                    ).then(result => {
                        this.$set(emp, "msjActualizacion", result.data.mensajesEmpresa)
                        
                    }, error => {
                        // mensaje = "Ups, Tuvimos un problema al actualizar, si el problema persiste contacte con nuestro soporte, Gracias."
                        
                        this.$set(emp, "msjActualizacion", error.response.data.mensajeGeneral)
                    })
                    .finally(() => {
                        this.$set(emp, "actualizando", false)
                        this.empresasFinalizadas.push(emp.codEmpresa)

                        let index = this.empresasActualizando.indexOf(emp.codEmpresa);
                        if (index > -1) {
                            this.empresasActualizando.splice(index, 1); 
                        }


                        
                        this.comprobarEmpresasActualizando()
                    });

                }
                /*
                this.isActualizandoEmpresas = true
                this.textoBtnActualizarEmpresas = "Sincronizando Información Empresas"
                this.classActualizar = "imgr"
                this.mensajesActualizacion = []
                this.mostrarMensajes = false
                
                
                let mensaje = ""

                const axiosSource = axios.CancelToken.source();
                this.rqstActualizarEmpresas = { cancel: axiosSource.cancel, msg: "Cargando..." };
                var url = this.urlBase + apiUrls.general.actualizarBd
                
                axios({
                    method: "POST", 
                    "url": url,
                    cancelToken: axiosSource.token,
                    "data": {
                        "info": {
                            "actualizarTodoCliente": true,
                            "idCliente": this.idCliente,
                            "empresasActualizar": [],
                            "tipoBd": this.tipoBd
                        }
                    },
                    "headers": {
                        'Authorization': this.tokenLogin
                    }
                }
                ).then(result => {
                    mensaje = result.data
                    this.mensajesActualizacion = mensaje.mensajesEmpresa
                    this.getUltimaActualizacion()
                    this.$notification.success(mensaje.mensajeGeneral, 
                        {  
                            timer: 10, position:"bottomRight", 
                            
                        }
                    );
                    
                }, error => {
                    // mensaje = "Ups, Tuvimos un problema al actualizar, si el problema persiste contacte con nuestro soporte, Gracias."
                    
                    this.$notification.error(error.response.data.mensajeGeneral, {  timer: 10, position:"bottomRight", showCloseIcn:true});
                })
                .finally(() => {
                    this.classActualizar = ""
                    this.isActualizandoEmpresas = false
                    this.textoBtnActualizarEmpresas
                    this.textoBtnActualizarEmpresas = "Actualizar Empresas"
                });*/

            },
            cancelarActualizarEmpresas: function(){
                if(this.rqstActualizarEmpresas != null){
                    this.rqstActualizarEmpresas.cancel()
                    this.rqstActualizarEmpresas.msg = "cancelado";
                    this.rqstActualizarEmpresas = null;
                    this.mostrarNotificaciones(4, "Se ha detenido la actualizacion");
                }
            },

            crearTippySicn: function(){
                let txtDif = `Última Sincronización ${ this.$utils.calcularDifecenciaDias(this.ultActualizacion) }`
                let txtDesde = this.isActualizandoEmpresas?`Cancelar Sincronización`:`Sincronizar Empresas de ${(this.tipoBd=='CONTA'?'Contabilidad':'Remuneraciones')}`
                if(this.isActualizandoEmpresas){
                    return 'Cancelar Sincronización'
                } else {
                    let txt = `Sincronizar Empresas de ${(this.tipoBd=='CONTA'?'Contabilidad':'Remuneraciones')}`
                    return `<div>${txt}</div><div>${txtDif}</div>`
                }
                
            },


        },
    };
</script>

<style scoped>


.btnPrincipalVappDrpw {
  background: linear-gradient(135deg, 
    #1f1b4e,  /* Tono más oscuro */
    #2e2a6f,  /* Primer matiz */
    #3b378e,  /* Color principal */
    #4a46a0,  /* Matiz intermedio */
    #514ec2,  /* Tono más claro */
    #6a67e5  /* Toque final más luminoso */
  );
  border-color: #3b378e;
  color: white !important;  /* Fuerza el color blanco */
  border-radius: 5px;
}

.btnPrincipalVappDrpw .btn {
    padding: 0;
  background: transparent;
  border: none;
  color: white !important;  /* Asegura que el texto en botones sea blanco */
  font-size: 0.5rem;
}

.btnPrincipalVappDrpw .btn span {
  color: white !important; /* Fuerza el color del texto dentro de los botones */
}

.btnPrincipalVappDrpw .dropdown-toggle {
  background: transparent;
  border: none;
  color: white !important; /* Asegura el color en el dropdown */
}
.btnPrincipalVappDrpw .dropdown-toggle .dropdown-toggle-split .btn{
    color: white !important;
}


.btnPrincipalVappDrpw .dropdown-toggle::after {
  border-top-color: white !important;  /* Color de la flecha del dropdown */
  border-right-color: transparent;
  border-left-color: transparent;
}
.btnPrincipalVappDrpw .dropdown-toggle .dropdown-toggle-split{
    color: white !important;
}

.btnPrincipalVappDrpw .btn-group .dropdown-toggle .dropdown-toggle-split .btn{
    color: white !important;
}

</style>